export default "__VITE_ASSET__Chm4pVWM__"